'use client'

import { getDictionary } from "@/app/[lang]/locales";
import { useEffect } from "react";

/**
 * Ce composant react enregistre les donnée d'une page dans le sessionStorage du client afin de maintenir celle-ci lorsque l'utilisateur décide de changer la langue de la page
 * 
 * @param {object} data - Donnée de la page
 * @param {string} data.type - Le nom/type de la page. Il s'agit d'un sélecteur permettant à la fonction de changement de langue de savoir quel page mettre à jour lors du changement de langue.
 * @param {object} data.data - Donnée de la page
 * @returns {null}
 */
export default function SetPageType ({data}){
    useEffect(()=>{
        sessionStorage.setItem("rma-website-pageType",JSON.stringify(data))
    })

    return null
    
}